import React from 'react';
import TeaserCard from '../../components/TeaserCard/TeaserCard';

const TeaserContent = ({ ...teaserContentProps }: TeaserContentProps) => {
  if (teaserContentProps === null) return null;

  const { data, isSmall } = teaserContentProps;

  return (
    <TeaserCard
      data={data}
      variant="content"
      isSmall={isSmall ? isSmall : false}
    />
  );
};

export type TeaserContentProps = {
  data: any;
  isSmall?: boolean;
} | null;

export default TeaserContent;
